import service from "../services/chat.service";

export const chat = {
  namespaced: true,
  actions: {
    async send(context, data) {
      try {
        return await service.send(data);
      } catch (error) {
        console.error("Error sending chat message:", error);
        throw error;
      }
    },
  },
};
